/**
 * Channel covers are cropped once at this ratio and rendered with the same
 * positioning rules everywhere they appear. Keeping these values together
 * prevents an additional, context-specific crop in previews and headers.
 */
export const CHANNEL_COVER_ASPECT_RATIO = 1.91;

export const CHANNEL_COVER_BACKGROUND_STYLES = {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
} as const;
